import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import axios from "../utils/axiosInstance";
import { useToast } from "./ConfirmDialog";
import { io } from "socket.io-client";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

const API = "";
const SOCKET_URL = process.env.REACT_APP_API_URL || (typeof window !== "undefined" ? window.location.origin : "http://localhost:5000");

const Styles = () => (
  <style>{`
.ir-container { max-width: 1200px; margin: 0 auto; }
.ir-header-card {
  background: linear-gradient(135deg, #003366 0%, #004080 100%);
  border-radius: 12px;
  padding: 20px 24px;
  margin-bottom: 20px;
  border-left: 5px solid #FFD700;
  box-shadow: 0 2px 8px rgba(0,51,102,0.2);
}
.ir-header-card h2 { color: #ffffff; font-size: 1.1rem; font-weight: 700; margin: 0; display: flex; align-items: center; gap: 10px; }
.ir-header-card p { color: rgba(255,255,255,0.7); font-size: 0.82rem; margin: 4px 0 0; }
.ir-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 20px;
}
.ir-tab {
  padding: 10px 20px;
  border-radius: 8px;
  border: 1px solid #d1d9e6;
  background: #ffffff;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  display: flex;
  align-items: center;
  gap: 6px;
}
.ir-tab:hover { border-color: #003366; color: #003366; background: #f8fafc; }
.ir-tab.active { background: #003366; color: #ffffff; border-color: #003366; box-shadow: 0 2px 8px rgba(0,51,102,0.25); }
.ir-tab i { font-size: 0.9rem; }
.ir-controls {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 16px;
  align-items: center;
}
.ir-search {
  flex: 1;
  min-width: 200px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 12px;
  background: #ffffff;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  height: 40px;
}
.ir-search i { color: #94a3b8; font-size: 0.9rem; }
.ir-search input {
  border: none;
  background: none;
  outline: none;
  flex: 1;
  font-size: 0.85rem;
  color: #1e293b;
  font-family: inherit;
}
.ir-search input::placeholder { color: #94a3b8; }
.ir-sort-select {
  padding: 8px 12px;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  font-size: 0.82rem;
  color: #475569;
  background: #ffffff;
  font-family: inherit;
  cursor: pointer;
}
.ir-table-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.ir-table-scroll { overflow-x: auto; }
.ir-table { width: 100%; border-collapse: collapse; font-size: 0.82rem; }
.ir-table th {
  text-align: left; padding: 12px 16px;
  font-size: 0.65rem; font-weight: 700; color: #64748b;
  text-transform: uppercase; letter-spacing: 0.07em;
  border-bottom: 2px solid #e2e8f0;
  background: #f8fafc; white-space: nowrap;
}
.ir-table td { padding: 12px 16px; border-bottom: 1px solid #f1f5f9; vertical-align: middle; color: #1e293b; }
.ir-table tbody tr:hover { background: #f0f4f8; }
.ir-table tbody tr:last-child td { border-bottom: none; }
.ir-empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #64748b;
}
.ir-empty-state i { font-size: 3rem; color: #cbd5e1; margin-bottom: 16px; display: block; }
.ir-empty-state p { font-size: 0.9rem; margin: 0; }
.ir-status { display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 12px; font-size: 0.72rem; font-weight: 600; }
.ir-status-sent { background: #d1fae5; color: #065f46; }
.ir-status-pending { background: #fef3c7; color: #b45309; }
.ir-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 14px 16px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
}
.ir-page-btn {
  min-width: 34px;
  height: 34px;
  border: 1px solid #d1d9e6;
  background: #ffffff;
  color: #475569;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  font-family: inherit;
}
.ir-page-btn:hover:not(:disabled) { background: #f1f5f9; border-color: #94a3b8; }
.ir-page-btn:disabled { opacity: 0.3; cursor: not-allowed; }
.ir-page-btn.active { background: #003366; color: #ffffff; border-color: #003366; }
.ir-info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.78rem;
  color: #64748b;
}
.ir-detail-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0,0,0,0.06);
}
.ir-detail-header {
  background: #003366;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 3px solid #FFD700;
}
.ir-detail-header i { color: #FFD700; font-size: 1.3rem; }
.ir-detail-header h3 { color: #ffffff; font-size: 1rem; font-weight: 700; margin: 0; }
.ir-detail-body { padding: 20px; }
.ir-field { margin-bottom: 12px; }
.ir-field-label { font-size: 0.72rem; font-weight: 600; color: #64748b; text-transform: uppercase; letter-spacing: 0.05em; }
.ir-field-value { font-size: 0.9rem; color: #1e293b; font-weight: 500; margin-top: 2px; }
.ir-btn-back {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #ffffff;
  border: 1px solid #d1d9e6;
  border-radius: 8px;
  color: #475569;
  font-size: 0.82rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.ir-btn-back:hover { background: #f8fafc; border-color: #003366; color: #003366; }
.ir-btn-sign {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #003366;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.ir-btn-sign:hover { background: #004080; }
.ir-btn-sign:disabled { opacity: 0.6; cursor: not-allowed; }
.signature-area {
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  padding: 16px;
  text-align: center;
  background: #f8fafc;
  margin-top: 8px;
}
.signature-area canvas {
  display: block;
  margin: 0 auto;
  max-width: 480px;
  width: 100%;
  height: auto;
  cursor: crosshair;
  touch-action: none;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
}
.signature-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
  margin-top: 10px;
  flex-wrap: wrap;
}
.signature-preview { max-height: 60px; display: block; margin: 8px auto; background: #fff; border-radius: 4px; padding: 4px; border: 1px solid #e2e8f0; }
.ir-send-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 14px 32px;
  background: #1a7a4a;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  width: 100%;
  justify-content: center;
}
.ir-send-btn:hover { background: #15803d; transform: translateY(-1px); box-shadow: 0 4px 16px rgba(26,122,74,0.3); }
.ir-send-btn:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
@media (max-width: 768px) {
  .ir-tabs { gap: 6px; }
  .ir-tab { padding: 8px 14px; font-size: 0.76rem; }
  .ir-table { font-size: 0.75rem; }
  .ir-table th, .ir-table td { padding: 8px 10px; }
}

/* ── GOVERNMENT DOCUMENT STYLES ── */
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@300;400;500;600;700;800;900&family=Noto+Serif:wght@400;700&display=swap');

.doc-page {
  background: #e8ecf1;
  min-height: 100vh;
  padding: 30px 16px;
  font-family: 'Nunito Sans', system-ui, sans-serif;
}
.doc-paper {
  width: 100%;
  max-width: 900px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10), 0 1px 4px rgba(0,0,0,0.06);
  padding: 50px 55px 40px;
  margin: 0 auto;
  position: relative;
  font-family: 'Nunito Sans', system-ui, sans-serif;
  color: #1e293b;
  overflow: hidden;
}
.doc-watermark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-30deg);
  font-size: 120px;
  font-weight: 900;
  color: rgba(26,58,92,0.025);
  pointer-events: none;
  white-space: nowrap;
  letter-spacing: 12px;
  text-transform: uppercase;
  z-index: 0;
  font-family: 'Noto Serif', serif;
}
.doc-header {
  text-align: center;
  padding-bottom: 28px;
  border-bottom: 3px solid #1a3a5c;
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.doc-header::after {
  content: '';
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: #d4a843;
  border-radius: 2px;
}
.doc-header-left { display: inline-block; vertical-align: middle; margin-bottom: 10px; }
.doc-header-left svg { width: 56px; height: 56px; }
.doc-header-center { }
.doc-header-right { position: absolute; top: 0; right: 0; text-align: right; }
.doc-header-republic {
  font-family: 'Noto Serif', serif;
  font-size: 18px;
  font-weight: 700;
  color: #1a3a5c;
  letter-spacing: 2.5px;
  text-transform: uppercase;
  margin: 0 0 4px;
}
.doc-header-ministry {
  font-family: 'Noto Serif', serif;
  font-size: 13px;
  font-weight: 600;
  color: #b8860b;
  text-transform: uppercase;
  margin: 4px 0;
  letter-spacing: 1px;
}
.doc-header-system {
  font-size: 10px;
  font-weight: 500;
  color: #888;
  margin: 2px 0 0;
}
.doc-ref-number {
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: #1a3a5c;
  padding: 6px 18px;
  border-radius: 20px;
  letter-spacing: 0.5px;
}
.doc-tracking {
  font-size: 9px;
  color: #999;
  margin-top: 4px;
  letter-spacing: 0.3px;
}
.doc-title-section {
  text-align: center;
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.doc-title {
  font-family: 'Noto Serif', serif;
  font-size: 24px;
  font-weight: 700;
  color: #1a3a5c;
  text-transform: uppercase;
  letter-spacing: 2px;
  margin: 0 0 8px;
}
.doc-title-ref {
  font-size: 13px;
  color: #666;
  margin: 0 0 4px;
}
.doc-title-date {
  font-size: 12px;
  color: #999;
  margin: 0 0 14px;
}
.doc-status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 18px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.doc-status-badge.approved { background: #DCFCE7; color: #16A34A; border: 1px solid #86EFAC; }
.doc-status-badge.pending { background: #FEF9C3; color: #CA8A04; border: 1px solid #FDE047; }
.doc-status-badge.rejected { background: #FEE2E2; color: #DC2626; border: 1px solid #FCA5A5; }
.doc-status-badge.under_review { background: #DBEAFE; color: #2563EB; border: 1px solid #93C5FD; }
.doc-status-badge.sent_to_akagari { background: #DCFCE7; color: #16A34A; border: 1px solid #86EFAC; }
.doc-status-badge.sent_to_umudugudu { background: #DBEAFE; color: #1a3a5c; border: 1px solid #93C5FD; }
.doc-section {
  margin-bottom: 28px;
  position: relative;
  z-index: 1;
}
.doc-section-title {
  font-size: 13px;
  font-weight: 700;
  color: #1a3a5c;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 8px 14px;
  background: #f1f5f9;
  border-left: 4px solid #1a3a5c;
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.doc-section-title i { font-size: 14px; color: #d4a843; }
.doc-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 24px;
}
.doc-info-item {
  padding: 6px 0;
}
.doc-info-label {
  font-size: 11px;
  font-weight: 600;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 2px;
}
.doc-info-value {
  font-size: 15px;
  font-weight: 500;
  color: #1e293b;
}
.doc-description-box {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 16px;
  background: #fafbfc;
  line-height: 1.8;
  font-size: 14px;
  color: #1e293b;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: pre-wrap;
}
.doc-evidence-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}
.doc-evidence-card {
  background: #fafbfc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 14px;
}
.doc-evidence-label {
  font-size: 10px;
  font-weight: 700;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}
.doc-evidence-value {
  font-size: 14px;
  color: #1e293b;
  font-weight: 500;
}
.doc-signature-area {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 14px;
  margin-top: 8px;
}
.doc-signature-box {
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  padding: 14px;
  text-align: center;
  background: #fafbfc;
}
.doc-signature-box-title {
  font-size: 10px;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}
.doc-signature-box-content {
  min-height: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.doc-signature-box-content img {
  max-height: 50px;
  display: block;
  border-radius: 3px;
  border: 1px solid #e2e8f0;
  padding: 3px;
  background: #fff;
}
.doc-signature-placeholder {
  width: 120px;
  height: 40px;
  border-bottom: 2px solid #ccc;
  margin: 0 auto 6px;
}
.doc-signature-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  margin-top: 4px;
}
.doc-signature-date {
  font-size: 10px;
  color: #999;
}
.doc-timeline {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px 0 8px;
  position: relative;
  z-index: 1;
}
.doc-timeline-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  flex: 1;
  position: relative;
  z-index: 2;
}
.doc-timeline-dot {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  border: 2px solid #d1d5db;
  background: #fff;
  color: #d1d5db;
  position: relative;
  z-index: 2;
}
.doc-timeline-dot.completed {
  background: #16a34a;
  border-color: #16a34a;
  color: #fff;
}
.doc-timeline-dot.current {
  background: #1a3a5c;
  border-color: #1a3a5c;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(26,58,92,0.2);
}
.doc-timeline-label {
  font-size: 10px;
  font-weight: 600;
  color: #999;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.3px;
}
.doc-timeline-label.completed { color: #16a34a; }
.doc-timeline-label.current { color: #1a3a5c; font-weight: 700; }
.doc-timeline-line {
  position: absolute;
  top: 17px;
  left: 0;
  width: 100%;
  height: 3px;
  background: #e2e8f0;
  z-index: 1;
}
.doc-timeline-line.completed {
  background: #16a34a;
}
.doc-footer {
  margin-top: 32px;
  padding-top: 20px;
  border-top: 2px solid #e2e8f0;
  text-align: center;
  position: relative;
  z-index: 1;
}
.doc-footer-republic {
  font-family: 'Noto Serif', serif;
  font-size: 14px;
  font-weight: 700;
  color: #1a3a5c;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin: 0 0 4px;
}
.doc-footer-text {
  font-size: 11px;
  color: #999;
  margin: 2px 0;
}
.doc-footer-divider {
  width: 60px;
  height: 2px;
  background: #d4a843;
  margin: 8px auto;
}
.doc-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-bottom: 16px;
  position: relative;
  z-index: 1;
}
.doc-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  text-decoration: none;
  min-height: 42px;
}
.doc-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.doc-btn-primary {
  background: #1a3a5c;
  color: #fff;
}
.doc-btn-primary:hover:not(:disabled) { background: #0f2a45; transform: translateY(-1px); box-shadow: 0 4px 12px rgba(26,58,92,0.3); }
.doc-btn-secondary {
  background: transparent;
  color: #1a3a5c;
  border: 1.5px solid #1a3a5c;
}
.doc-btn-secondary:hover { background: #eff6ff; }
.doc-btn-back {
  background: transparent;
  color: #475569;
  border: 1px solid #d1d9e6;
}
.doc-btn-back:hover { background: #f1f5f9; border-color: #94a3b8; }
.doc-verification-code {
  text-align: center;
  margin-top: 16px;
  padding: 8px 0;
  position: relative;
  z-index: 1;
}
.doc-verification-code span {
  font-size: 10px;
  color: #999;
  letter-spacing: 2px;
  font-family: 'Courier New', monospace;
  background: #f8fafc;
  padding: 4px 12px;
  border-radius: 3px;
  border: 1px dashed #ddd;
}

  @keyframes pdfSpin { to { transform: rotate(360deg); } }
  .coat-of-arms-svg {
    width: 56px;
    height: 56px;
  }

@media (max-width: 768px) {
  .doc-paper { padding: 24px 20px; }
  .doc-header { padding-bottom: 20px; }
  .doc-header-right { position: static; text-align: center; margin-top: 12px; }
  .doc-title { font-size: 20px; }
  .doc-info-grid { grid-template-columns: 1fr; }
  .doc-evidence-grid { grid-template-columns: 1fr; }
  .doc-signature-area { grid-template-columns: 1fr 1fr; gap: 12px; }
  .doc-timeline { flex-wrap: wrap; gap: 8px; justify-content: center; }
  .doc-timeline-step { flex: 0 0 30%; }
}
@media (max-width: 480px) {
  .doc-paper { padding: 16px 14px; }
  .doc-header-republic { font-size: 15px; }
  .doc-title { font-size: 17px; }
  .doc-signature-area { grid-template-columns: 1fr; }
}

/* ── PRINT STYLES ── */
@media print {
  @page { margin: 20mm; size: A4; }
  body { background: #fff !important; margin: 0 !important; padding: 0 !important; }
  .doc-page { background: #fff !important; padding: 0 !important; min-height: auto !important; }
  .doc-paper {
    box-shadow: none !important;
    border-radius: 0 !important;
    max-width: 100% !important;
    padding: 0 !important;
    margin: 0 !important;
  }
  .doc-actions { display: none !important; }
  .no-print { display: none !important; }
  .doc-header { border-bottom-color: #1a3a5c !important; }
  .doc-header::after { background: #d4a843 !important; }
  .doc-section-title { border-left-color: #1a3a5c !important; background: #f1f5f9 !important; }
  .doc-title { color: #1a3a5c !important; }
  .doc-footer-republic { color: #1a3a5c !important; }
  .doc-footer-divider { background: #d4a843 !important; }
  .doc-status-badge,
  .doc-timeline-dot.completed,
  .doc-timeline-dot.current,
  .doc-timeline-line.completed { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
  .coat-of-arms-svg { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
}
  `}</style>
);

function SignaturePad({ onSave }) {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const lastPos = useRef(null);
  const [sigData, setSigData] = useState(null);

  const getPos = (e, canvas) => {
    const r = canvas.getBoundingClientRect();
    const src = e.touches ? e.touches[0] : e;
    return { x: (src.clientX - r.left) * (canvas.width / r.width), y: (src.clientY - r.top) * (canvas.height / r.height) };
  };

  const start = (e) => { e.preventDefault(); drawing.current = true; lastPos.current = getPos(e, canvasRef.current); };
  const move = (e) => {
    e.preventDefault();
    if (!drawing.current) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    const pos = getPos(e, canvas);
    ctx.beginPath();
    ctx.moveTo(lastPos.current.x, lastPos.current.y);
    ctx.lineTo(pos.x, pos.y);
    ctx.strokeStyle = "#003366";
    ctx.lineWidth = 2.5;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.stroke();
    lastPos.current = pos;
  };
  const stop = () => { drawing.current = false; };

  const isEmpty = () => {
    const canvas = canvasRef.current;
    if (!canvas) return true;
    const ctx = canvas.getContext("2d");
    const pixels = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    for (let i = 3; i < pixels.length; i += 4) {
      if (pixels[i] > 0) return false;
    }
    return true;
  };

  const handleSave = () => {
    if (isEmpty()) { alert("Nyamukono wambere!"); return; }
    const data = canvasRef.current.toDataURL("image/png");
    setSigData(data);
    onSave(data);
  };
  const handleClear = () => {
    const canvas = canvasRef.current;
    if (canvas) canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
    setSigData(null);
    onSave(null);
  };

  return (
    <div>
      <div className="signature-area">
        <canvas
          ref={canvasRef}
          width={480} height={120}
          onMouseDown={start} onMouseMove={move} onMouseUp={stop} onMouseLeave={stop}
          onTouchStart={start} onTouchMove={move} onTouchEnd={stop}
          style={{ display: "block", maxHeight: 120 }}
        />
        <div className="signature-actions">
          <button onClick={handleClear} className="if-btn-danger" type="button" style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "#dc2626", color: "#fff", border: "none", borderRadius: 6, fontSize: "0.75rem", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
            <i className="bi bi-eraser" /> Gukuraho
          </button>
          <button onClick={handleSave} className="if-btn-primary" type="button" style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 14px", background: "#003366", color: "#fff", border: "none", borderRadius: 6, fontSize: "0.75rem", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>
            <i className="bi bi-check-lg" /> Emeza Umukono
          </button>
        </div>
      </div>
      {sigData && (
        <div style={{ textAlign: "center", marginTop: 8 }}>
          <img src={sigData} alt="Umukono" className="signature-preview" />
          <div style={{ fontSize: "0.72rem", color: "#15803d", fontWeight: 600 }}>Umukono wemejwe</div>
        </div>
      )}
    </div>
  );
}

export default function IbiregoMudugudu() {
  const { toast } = useToast();
  const [allRecords, setAllRecords] = useState([]);
  const [isiboNames, setIsiboNames] = useState([]);
  const [activeIsibo, setActiveIsibo] = useState(null);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("newest");
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [detail, setDetail] = useState(null);
  const [detailLoading, setDetailLoading] = useState(false);
  const [muduguduName, setMuduguduName] = useState("");
  const [muduguduSig, setMuduguduSig] = useState(null);
  const [signingIn, setSigningIn] = useState(false);
  const [sendingToAkagari, setSendingToAkagari] = useState(false);
  const perPage = 10;

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const [recordsRes, namesRes] = await Promise.all([
        axios.get(`${API}/api/isibo/ibirego`),
        axios.get(`${API}/api/isibo/ibirego/isibo-names`),
      ]);
      setAllRecords(recordsRes.data || []);
      const names = namesRes.data || [];
      setIsiboNames(names);
      if (!activeIsibo && names.length > 0) {
        setActiveIsibo(names[0]);
      } else if (activeIsibo && !names.includes(activeIsibo)) {
        setActiveIsibo(names.length > 0 ? names[0] : null);
      }
    } catch {
      toast({ type: "danger", title: "Ikosa", message: "Habaye ikosa mu gupanga amakuru" });
    } finally {
      setLoading(false);
    }
  }, [activeIsibo]);

  useEffect(() => { fetchData(); }, []);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const socket = io(SOCKET_URL, {
      auth: { token },
      transports: ["websocket", "polling"],
    });
    socket.on("connect", () => {});
    socket.on("isibo-ibirego-updated", () => {
      fetchData();
      if (selectedComplaint) loadDetail(selectedComplaint);
    });
    return () => { socket.disconnect(); };
  }, [fetchData, selectedComplaint]);

  const filteredRecords = useMemo(() => {
    let items = allRecords;
    if (activeIsibo) {
      items = items.filter((r) => r.izina_isibo === activeIsibo);
    }
    if (search) {
      const q = search.toLowerCase();
      items = items.filter(
        (r) =>
          (r.complainant_name || "").toLowerCase().includes(q) ||
          (r.national_id || "").toLowerCase().includes(q) ||
          (r.phone || "").toLowerCase().includes(q)
      );
    }
    items.sort((a, b) => {
      const da = new Date(a.created_at || 0).getTime();
      const db = new Date(b.created_at || 0).getTime();
      return sortOrder === "newest" ? db - da : da - db;
    });
    return items;
  }, [allRecords, activeIsibo, search, sortOrder]);

  const totalPages = Math.max(1, Math.ceil(filteredRecords.length / perPage));
  const paginatedRecords = filteredRecords.slice((page - 1) * perPage, page * perPage);
  useEffect(() => { setPage(1); }, [activeIsibo, search, sortOrder]);

  const formatDate = (d) => {
    if (!d) return "";
    return new Date(d).toLocaleDateString("rw-RW", { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" });
  };

  const loadDetail = async (id) => {
    setDetailLoading(true);
    setSelectedComplaint(id);
    try {
      const res = await axios.get(`${API}/api/isibo/ibirego/${id}`);
      setDetail(res.data);
    } catch {
      toast({ type: "danger", title: "Ikosa", message: "Ntibashobotse gupanga amakuru" });
    } finally {
      setDetailLoading(false);
    }
  };

  const handleSignAndSend = async () => {
    if (!muduguduName.trim()) {
      toast({ type: "warning", title: "Ikosa", message: "Andika izina ryawe" });
      return;
    }
    if (!muduguduSig) {
      toast({ type: "warning", title: "Ikosa", message: "Nyamukono wambere!" });
      return;
    }
    setSigningIn(true);
    try {
      await axios.post(`${API}/api/isibo/ibirego/${detail.id}/umudugudu-signature`, {
        umudugudu_name: muduguduName.trim(),
        signature_image: muduguduSig,
      });
      toast({ type: "success", title: "Byakunze!", message: "Umukono wabitswe neza!" });
      await axios.patch(`${API}/api/isibo/ibirego/${detail.id}/send-to-akagari`);
      toast({ type: "success", title: "Byoherejwe!", message: "Icyirego cyoherejwe ku Kagari!" });
      setDetail(null);
      setSelectedComplaint(null);
      setMuduguduName("");
      setMuduguduSig(null);
      fetchData();
    } catch (err) {
      const msg = err.response?.data?.error || "Habaye ikosa";
      toast({ type: "danger", title: "Ikosa", message: msg });
    } finally {
      setSigningIn(false);
    }
  };

  const getStatusConfig = (status) => {
    const configs = {
      approved: { label: "Byemejwe", cls: "approved" },
      pending: { label: "Itegereje", cls: "pending" },
      rejected: { label: "Byanzwe", cls: "rejected" },
      under_review: { label: "Burebwa", cls: "under_review" },
      sent_to_akagari: { label: "Yoherejwe ku Kagari", cls: "sent_to_akagari" },
      sent_to_umudugudu: { label: "Yoherejwe ku Mudugudu", cls: "sent_to_umudugudu" },
    };
    return configs[status] || { label: status?.replace(/_/g, " ") || "Itegereje", cls: "pending" };
  };

  const timelineSteps = [
    { key: "submitted", label: "Byatanzwe" },
    { key: "received", label: "Byakiriwe" },
    { key: "under_review", label: "Burebwa" },
    { key: "processed", label: "Byakozwe" },
    { key: "closed", label: "Byafunzwe" },
  ];

  const getStepStatus = (stepKey, currentStatus) => {
    const order = ["submitted", "received", "under_review", "processed", "closed"];
    const statusOrder = {
      pending: 0,
      sent_to_umudugudu: 1,
      signed: 1,
      sent_to_akagari: 2,
      approved: 3,
      rejected: 3,
      closed: 4,
    };
    const currentIdx = statusOrder[currentStatus] ?? 0;
    const stepIdx = order.indexOf(stepKey);
    if (stepIdx < currentIdx) return "completed";
    if (stepIdx === currentIdx) return "current";
    return "";
  };

  const generateRefNumber = (id) => {
    const prefix = "RWA-CCMS";
    const date = new Date();
    const yr = date.getFullYear();
    const seq = String(id || 0).padStart(5, "0");
    return `${prefix}-${yr}-${seq}`;
  };

  const generateVerificationCode = (id) => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let code = "";
    for (let i = 0; i < 12; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return `VER-${code}-${String(id || 0).slice(-3)}`;
  };

  const [pdfGenerating, setPdfGenerating] = useState(false);
  const [pdfProgress, setPdfProgress] = useState('');

  const handlePrint = () => {
    window.print();
  };

  const handleDownloadPdf = useCallback(async () => {
    setPdfGenerating(true);
    setPdfProgress('Preparing document...');

    try {
      const element = document.getElementById('mudugudu-document-content');
      if (!element) {
        setPdfGenerating(false);
        return;
      }

      setPdfProgress('Capturing document...');

      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#ffffff',
        logging: false,
        width: element.scrollWidth,
        height: element.scrollHeight,
        windowWidth: element.scrollWidth,
        windowHeight: element.scrollHeight,
      });

      setPdfProgress('Generating PDF...');

      const imgData = canvas.toDataURL('image/jpeg', 0.98);
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      const pdf = new jsPDF('p', 'mm', 'a4');
      let heightLeft = imgHeight;
      let position = 0;
      const pageHeight = 297;
      const margin = 12;

      pdf.addImage(imgData, 'JPEG', margin, position + margin, imgWidth - 2 * margin, imgHeight);

      heightLeft -= pageHeight - 2 * margin;

      while (heightLeft > 0) {
        position = heightLeft - imgHeight + (pageHeight - 2 * margin);
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', margin, position + margin, imgWidth - 2 * margin, imgHeight);
        heightLeft -= pageHeight - 2 * margin;
      }

      setPdfProgress('Saving...');
      const refNumber = generateRefNumber(detail?.id);
      pdf.save(`icyirego_${refNumber || detail?.id || 'unknown'}.pdf`);
    } catch (err) {
      console.error('PDF generation error:', err);
    } finally {
      setPdfGenerating(false);
      setPdfProgress('');
    }
  }, [detail]);

  const RwandaCoatOfArms = () => (
    <svg className="coat-of-arms-svg" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
      <circle cx="50" cy="50" r="48" fill="none" stroke="#005BAC" strokeWidth="1.5" />
      <circle cx="50" cy="52" r="20" fill="#FAD201" opacity="0.3" />
      <circle cx="50" cy="52" r="14" fill="#FAD201" opacity="0.5" />
      <circle cx="50" cy="52" r="8" fill="#FAD201" />
      {[0,45,90,135,180,225,270,315].map((angle, i) => (
        <line key={i} x1="50" y1="52" x2={50 + 22 * Math.cos(angle * Math.PI / 180)} y2={52 + 22 * Math.sin(angle * Math.PI / 180)} stroke="#FAD201" strokeWidth="2" opacity="0.6" />
      ))}
      <path d="M34 58 Q42 72 58 72 Q66 58 58 58 Q50 64 42 58 Z" fill="#005BAC" />
      <rect x="38" y="72" width="24" height="6" rx="1" fill="#8B4513" />
      <path d="M32 80 Q50 88 68 80" fill="none" stroke="#228B22" strokeWidth="2" />
      <path d="M28 82 Q20 76 18 70" fill="none" stroke="#228B22" strokeWidth="2" />
      <path d="M72 82 Q80 76 82 70" fill="none" stroke="#228B22" strokeWidth="2" />
      <text x="50" y="20" textAnchor="middle" fontSize="5" fontWeight="700" fill="#005BAC">UBUMWE</text>
      <text x="50" y="26" textAnchor="middle" fontSize="5" fontWeight="700" fill="#005BAC">UMURIMO</text>

    </svg>
  );

  const QRCodeSVG = ({ value, size }) => (
    <svg width={size || 70} height={size || 70} viewBox="0 0 70 70" xmlns="http://www.w3.org/2000/svg">
      <rect width="70" height="70" fill="#fff" rx="2" />
      <g fill="#005BAC">
        {[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69].map(i => {
          const x = i % 70;
          const y = Math.floor(i / 70);
          if ((x < 14 && y < 14) || (x > 55 && y < 14) || (x < 14 && y > 55)) {
            if ((x < 7 && y < 7) || (x > 62 && y < 7) || (x < 7 && y > 62)) return <rect key={i} x={x} y={y} width="1" height="1" fill="#005BAC" />;
            if (x >= 7 && x < 14 && y >= 7 && y < 14) return null;
            if (x >= 56 && x < 63 && y >= 7 && y < 14) return null;
            if (x >= 7 && x < 14 && y >= 56 && y < 63) return null;
            return null;
          }
          return null;
        })}
        <rect x="3" y="3" width="8" height="8" rx="1" fill="none" stroke="#005BAC" strokeWidth="1.5" />
        <rect x="59" y="3" width="8" height="8" rx="1" fill="none" stroke="#005BAC" strokeWidth="1.5" />
        <rect x="3" y="59" width="8" height="8" rx="1" fill="none" stroke="#005BAC" strokeWidth="1.5" />
      </g>
    </svg>
  );

  if (detail) {
    const d = detail;
    const statusCfg = getStatusConfig(d.status);
    const refNumber = generateRefNumber(d.id);
    const verificationCode = generateVerificationCode(d.id);
    const qrData = `RWA-CCMS:${refNumber}:VER:${verificationCode}`;
    const today = new Date().toLocaleDateString("rw-RW", { year: "numeric", month: "long", day: "numeric" });

    return (
      <>
        <Styles />
        {pdfGenerating && (
          <div style={{
            position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
            background: 'rgba(255,255,255,0.92)', display: 'flex',
            flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            zIndex: 99999, fontFamily: 'Nunito Sans, sans-serif'
          }}>
            <div style={{
              width: 48, height: 48,
              border: '4px solid #e0e0e0', borderTopColor: '#003366',
              borderRadius: '50%', animation: 'pdfSpin 0.8s linear infinite',
              marginBottom: 16
            }} />
            <div style={{ fontSize: 16, fontWeight: 600, color: '#003366' }}>
              {pdfProgress || 'Generating PDF...'}
            </div>
          </div>
        )}

        <div className="doc-page no-print">
          <div className="doc-actions">
            <button className="doc-btn doc-btn-back" onClick={() => { setDetail(null); setSelectedComplaint(null); }}>
              <i className="bi bi-arrow-left" /> Subira
            </button>
            <button className="doc-btn doc-btn-secondary" onClick={handlePrint}>
              <span style={{ fontSize: 16, marginRight: 4 }}>🖨️</span> Iwandike
            </button>
            <button
              className="doc-btn doc-btn-primary"
              onClick={handleDownloadPdf}
              disabled={pdfGenerating}
            >
              <span style={{ fontSize: 16, marginRight: 4 }}>📥</span>
              {pdfGenerating ? 'Bitegereza...' : 'Download PDF'}
            </button>
          </div>
        </div>

        <div className="doc-page" id="mudugudu-document-content">
          <div className="doc-paper">
            <div className="doc-watermark">REPUBULIKA Y'U RWANDA</div>

            {/* ── OFFICIAL HEADER ── */}
            <div className="doc-header">
              <div className="doc-header-left">
                <RwandaCoatOfArms />
              </div>
              <div className="doc-header-center">
                <p className="doc-header-republic">Repubulika y'u Rwanda</p>
                <p className="doc-header-ministry">Minisiteri y'Ubutegetsi bw'Igihugu</p>
                <p className="doc-header-system">Inkingi | Village Management System</p>
              </div>
              <div className="doc-header-right">
                <QRCodeSVG value={qrData} size={65} />
                <div className="doc-tracking">Ver: {verificationCode}</div>
              </div>
            </div>

            {/* ── REFERENCE ── */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, position: "relative", zIndex: 1 }}>
              <span className="doc-ref-number">Ref: {refNumber}</span>
              <span className="doc-ref-number">Itariki: {today}</span>
            </div>

            {/* ── DOCUMENT TITLE ── */}
            <div className="doc-title-section">
              <h1 className="doc-title">Ibisobanuro by'Icyirego</h1>
              <p className="doc-title-ref">Icyirego cyoherejwe binyuze muri sisitemu</p>
              <p className="doc-title-date">Itariki yo gutanga: {formatDate(d.created_at)}</p>
              <span className={`doc-status-badge ${statusCfg.cls}`}>
                <i className={`bi ${d.status === "sent_to_akagari" ? "bi-check-circle" : d.status === "sent_to_umudugudu" ? "bi-check-circle" : "bi-clock"}`} />
                {statusCfg.label}
              </span>
            </div>

            {/* ── SECTION 1: AMAKURU Y'UWATANZE IKIREGO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-person-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Amakuru y'Uwatanze Ikirego
              </h2>
              <div className="doc-info-grid">
                <div className="doc-info-item">
                  <div className="doc-info-label">Amazina</div>
                  <div className="doc-info-value">{d.complainant_name}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Indangamuntu</div>
                  <div className="doc-info-value">{d.national_id || "-"}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Telephone</div>
                  <div className="doc-info-value">{d.phone || "-"}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Aho atuye</div>
                  <div className="doc-info-value">{d.location || d.izina_isibo || "-"}</div>
                </div>
              </div>
            </div>

            {/* ── SECTION 2: IBISOBANURO BY'IKIREGO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-file-text-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Ibisobanuro by'Ikirego
              </h2>
              <div className="doc-description-box">
                {d.description || "Nta bisobanuro byatanzwe"}
              </div>
            </div>

            {/* ── SECTION 3: AMAKURU Y'INYONGERAMUSARURO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-people-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Amakuru y'Inyongeramusaruro
              </h2>

              {d.witnesses && d.witnesses.length > 0 ? (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                    <i className="bi bi-person-check-fill" style={{ color: "#005BAC", fontSize: 14 }} />
                    <span style={{ fontSize: 13, fontWeight: 600, color: "#333" }}>Abanyamuhamya</span>
                  </div>
                  <div className="doc-evidence-grid">
                    {d.witnesses.map((w, i) => (
                      <div key={w.id || i} className="doc-evidence-card" style={{ borderLeft: "4px solid #005BAC" }}>
                        <div className="doc-evidence-label">Umuhamya {i + 1}</div>
                        <div className="doc-evidence-value" style={{ marginBottom: 4, fontSize: 15 }}>{w.witness_name}</div>
                        {w.signed_at && (
                          <>
                            <div className="doc-evidence-label" style={{ marginTop: 8 }}>Itariki</div>
                            <div className="doc-evidence-value" style={{ fontSize: 13 }}>{formatDate(w.signed_at)}</div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <div className="doc-evidence-card" style={{ padding: "14px 16px", marginBottom: 4, borderLeft: "4px solid #94a3b8" }}>
                  <div className="doc-evidence-value" style={{ color: "#888", fontSize: 13 }}>Nta banyamuhamya bagaragajwe</div>
                </div>
              )}

              <div className="doc-info-grid" style={{ marginTop: 16, paddingTop: 16, borderTop: "1px dashed #E2E8F0" }}>
                <div className="doc-info-item">
                  <div className="doc-info-label">Isibo</div>
                  <div className="doc-info-value">{d.izina_isibo || "-"}</div>
                </div>
                <div className="doc-info-item">
                  <div className="doc-info-label">Icyoherejwe</div>
                  <div className="doc-info-value">{d.sent_at ? formatDate(d.sent_at) : "Ntibyoherejwe"}</div>
                </div>
              </div>
            </div>

            {/* ── SECTION 4: UMWANYA W'UMUKONO ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-pen-fill" style={{ marginRight: 8, fontSize: 14 }} />
                Umwanya w'Umukono
              </h2>
              <div className="doc-signature-area">
                <div className="doc-signature-box" style={{ borderTop: "3px solid #005BAC" }}>
                  <div className="doc-signature-box-title">Uwatanze Ikirego</div>
                  <div className="doc-signature-box-content">
                    {d.signatures && d.signatures.length > 0 ? (
                      d.signatures.map((sig, i) => (
                        <div key={sig.id || i}>
                          {sig.signature_image && <img src={sig.signature_image} alt="Umukono" style={{ maxHeight: 55 }} />}
                          <div style={{ width: "100%", height: 2, background: "#005BAC", margin: "6px 0" }} />
                          <div className="doc-signature-name">{sig.signed_by}</div>
                          <div className="doc-signature-date">{sig.signed_at ? formatDate(sig.signed_at) : ""}</div>
                        </div>
                      ))
                    ) : (
                      <>
                        <div className="doc-signature-placeholder" />
                        <div className="doc-signature-date">Umukono</div>
                      </>
                    )}
                  </div>
                </div>

                <div className="doc-signature-box" style={{ borderTop: "3px solid #20603D" }}>
                  <div className="doc-signature-box-title">Ushinzwe Umutekano</div>
                  <div className="doc-signature-box-content">
                    {d.umudugudu_signatures && d.umudugudu_signatures.length > 0 ? (
                      d.umudugudu_signatures.map((ms, i) => (
                        <div key={ms.id || i}>
                          {ms.signature_image && <img src={ms.signature_image} alt="Umukono" style={{ maxHeight: 55 }} />}
                          <div style={{ width: "100%", height: 2, background: "#20603D", margin: "6px 0" }} />
                          <div className="doc-signature-name">{ms.umudugudu_name}</div>
                          <div className="doc-signature-date">{ms.signed_at ? formatDate(ms.signed_at) : ""}</div>
                        </div>
                      ))
                    ) : (
                      <>
                        <div className="doc-signature-placeholder" />
                        <div className="doc-signature-date">Umukono</div>
                      </>
                    )}
                  </div>
                </div>

                <div className="doc-signature-box" style={{ borderTop: "3px solid #F59E0B" }}>
                  <div className="doc-signature-box-title">Umukono wa Digitari</div>
                  <div className="doc-signature-box-content">
                    <div style={{ width: 60, height: 60, borderRadius: "50%", border: "3px solid #005BAC", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 8px", background: "#EFF6FF" }}>
                      <i className="bi bi-shield-fill-check" style={{ fontSize: 28, color: "#005BAC" }} />
                    </div>
                    <div className="doc-signature-name" style={{ fontSize: 11, color: "#005BAC" }}>Digital Signature</div>
                    <div style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "2px 10px", background: "#DCFCE7", borderRadius: 10, fontSize: 10, fontWeight: 600, color: "#16A34A", marginTop: 4 }}>
                      <i className="bi bi-patch-check-fill" /> Verified
                    </div>
                  </div>
                </div>
              </div>

              {/* Umudugudu Signature and Send Section */}
              {d.status === "sent_to_umudugudu" && (
                <div style={{ marginTop: 24, borderTop: "2px solid #FFD700", paddingTop: 20, position: "relative", zIndex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
                    <div style={{ width: 36, height: 36, borderRadius: 8, background: "#003366", display: "flex", alignItems: "center", justifyContent: "center" }}>
                      <i className="bi bi-shield-check" style={{ color: "#FFD700", fontSize: 18 }} />
                    </div>
                    <div>
                      <h5 style={{ fontSize: "0.9rem", fontWeight: 700, color: "#003366", margin: 0 }}>Umuyobozi w'Umudugudu</h5>
                      <p style={{ fontSize: "0.75rem", color: "#64748b", margin: "2px 0 0" }}>Nyamukono hano wohereze icyirego ku Kagari</p>
                    </div>
                  </div>

                  {d.umudugudu_signatures && d.umudugudu_signatures.length > 0 && (
                    <div style={{ marginBottom: 16, padding: 16, background: "#F0FDF4", borderRadius: 8, border: "1px solid #BBF7D0" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "0.82rem", fontWeight: 600, color: "#15803d", marginBottom: 8 }}>
                        <i className="bi bi-check-circle-fill" /> Umukono w'Umudugudu wemejwe
                      </div>
                      {d.umudugudu_signatures.map((ms) => (
                        <div key={ms.id} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                          {ms.signature_image && <img src={ms.signature_image} alt="Umukono" style={{ maxHeight: 50, borderRadius: 4 }} />}
                          <div>
                            <div style={{ fontWeight: 600, color: "#1e293b" }}>{ms.umudugudu_name}</div>
                            <div style={{ fontSize: "0.72rem", color: "#64748b" }}>{ms.signed_at ? formatDate(ms.signed_at) : ""}</div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {(!d.umudugudu_signatures || d.umudugudu_signatures.length === 0) && (
                    <>
                      <div className="if-group" style={{ marginBottom: 12 }}>
                        <label style={{ display: "block", fontSize: "0.78rem", fontWeight: 600, color: "#1e293b", marginBottom: 6 }}>Andika Izina ryawe <span style={{ color: "#dc2626" }}>*</span></label>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, border: "1px solid #d1d9e6", borderRadius: 8, padding: "0 12px", background: "#f8fafc" }}>
                          <i className="bi bi-person" style={{ color: "#94a3b8" }} />
                          <input
                            type="text"
                            value={muduguduName}
                            onChange={(e) => setMuduguduName(e.target.value)}
                            placeholder="Izina ry'Umuyobozi w'Umudugudu"
                            style={{ flex: 1, border: "none", background: "none", outline: "none", padding: "10px 0", fontSize: "0.85rem", color: "#1e293b", fontFamily: "inherit" }}
                          />
                        </div>
                      </div>
                      <div style={{ marginBottom: 16 }}>
                        <label style={{ display: "block", fontSize: "0.78rem", fontWeight: 600, color: "#1e293b", marginBottom: 6 }}>Nyamukono hano <span style={{ color: "#dc2626" }}>*</span></label>
                        <SignaturePad onSave={(data) => setMuduguduSig(data)} />
                      </div>
                      <button className="ir-send-btn" onClick={handleSignAndSend} disabled={signingIn || !muduguduName.trim() || !muduguduSig}>
                        {signingIn ? <><span className="spinner-border spinner-border-sm" /> Bitegereza...</> : <><i className="bi bi-send-fill" /> OHEREZA KU KAGARI</>}
                      </button>
                    </>
                  )}

                  {d.umudugudu_signatures && d.umudugudu_signatures.length > 0 && d.status === "sent_to_umudugudu" && (
                    <button className="ir-send-btn" onClick={async () => {
                      setSendingToAkagari(true);
                      try {
                        await axios.patch(`${API}/api/isibo/ibirego/${d.id}/send-to-akagari`);
                        toast({ type: "success", title: "Byoherejwe!", message: "Icyirego cyoherejwe ku Kagari!" });
                        setDetail(null);
                        setSelectedComplaint(null);
                        fetchData();
                      } catch (err) {
                        const msg = err.response?.data?.error || "Habaye ikosa";
                        toast({ type: "danger", title: "Ikosa", message: msg });
                      } finally {
                        setSendingToAkagari(false);
                      }
                    }} disabled={sendingToAkagari}>
                      {sendingToAkagari ? <><span className="spinner-border spinner-border-sm" /> Bitegereza...</> : <><i className="bi bi-send-fill" /> OHEREZA KU KAGARI</>}
                    </button>
                  )}
                </div>
              )}

              {d.sent_to_akagari_at && (
                <div style={{ marginTop: 16, padding: "10px 16px", background: "#F0FDF4", border: "1px solid #BBF7D0", borderRadius: 8, textAlign: "center", position: "relative", zIndex: 1 }}>
                  <i className="bi bi-check-circle-fill" style={{ color: "#16A34A", marginRight: 6 }} />
                  <span style={{ fontSize: 13, fontWeight: 600, color: "#15803D" }}>
                    Icyirego cyoherejwe ku Kagari: {formatDate(d.sent_to_akagari_at)}
                  </span>
                </div>
              )}
            </div>

            {/* ── STATUS TIMELINE ── */}
            <div className="doc-section">
              <h2 className="doc-section-title">
                <i className="bi bi-graph-up-arrow" style={{ marginRight: 8, fontSize: 14 }} />
                Inkingi y'Iterambere ry'Ikirego
              </h2>
              <div className="doc-timeline">
                <div className="doc-timeline-line" />
                <div className="doc-timeline-line completed" style={{ width: `${(timelineSteps.findIndex(s => getStepStatus(s.key, d.status) === "current") >= 0 ? timelineSteps.findIndex(s => getStepStatus(s.key, d.status) === "current") : 0) / (timelineSteps.length - 1) * 100}%` }} />
                {timelineSteps.map((step, idx) => {
                  const stepStatus = getStepStatus(step.key, d.status);
                  return (
                    <div key={step.key} className="doc-timeline-step">
                      <div className={`doc-timeline-dot ${stepStatus}`}>
                        {stepStatus === "completed" ? <i className="bi bi-check" style={{ fontSize: 16 }} /> : stepStatus === "current" ? <i className="bi bi-circle-fill" style={{ fontSize: 8 }} /> : idx + 1}
                      </div>
                      <div className={`doc-timeline-label ${stepStatus}`}>{step.label}</div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* ── VERIFICATION ── */}
            <div className="doc-verification-code">
              <span>Inyandiko y'ubutumwa: {verificationCode}</span>
            </div>

            {/* ── OFFICIAL FOOTER ── */}
            <div className="doc-footer">
              <div className="doc-footer-divider" />
              <p className="doc-footer-republic">Repubulika y'u Rwanda</p>
              <p className="doc-footer-text">Inkingi - Sisitemu yo Gucunga neza Imirimo</p>
              <p className="doc-footer-text" style={{ fontSize: 9 }}>Iyi nyandiko yakozwe kuri sisitemu ya Inkingi | © {new Date().getFullYear()}</p>
            </div>

          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <Styles />
      <div className="ir-container">
        <div className="ir-header-card">
          <h2><i className="bi bi-file-earmark-text" /> Ibirego Bivuye ku Isibo</h2>
          <p>Reba ibirego byoherejwe n'Isibo ziri munsi y'Umudugudu wawe</p>
        </div>

        {isiboNames.length > 0 ? (
          <div className="ir-tabs">
            {isiboNames.map((name) => (
              <button
                key={name}
                className={`ir-tab ${activeIsibo === name ? "active" : ""}`}
                onClick={() => setActiveIsibo(name)}
              >
                <i className={`bi ${activeIsibo === name ? "bi-folder-fill" : "bi-folder"}`} />
                {name}
              </button>
            ))}
          </div>
        ) : !loading ? (
          <div className="ir-empty-state">
            <i className="bi bi-inbox" />
            <p>Nta birego byoherejwe n'iyi Sibo</p>
          </div>
        ) : null}

        <div className="ir-controls">
          <div className="ir-search">
            <i className="bi bi-search" />
            <input
              type="text"
              placeholder="Shakisha ku izina, indangamuntu, telephone..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {search && (
              <button
                onClick={() => setSearch("")}
                style={{ background: "none", border: "none", color: "#94a3b8", cursor: "pointer", padding: 0 }}
              >
                <i className="bi bi-x-lg" />
              </button>
            )}
          </div>
          <select className="ir-sort-select" value={sortOrder} onChange={(e) => setSortOrder(e.target.value)}>
            <option value="newest">Bishya ku Ikarabuye</option>
            <option value="oldest">Bikera ku Ikarabuye</option>
          </select>
        </div>

        <div className="ir-table-card">
          <div className="ir-info-bar">
            <span><i className="bi bi-funnel" /> {filteredRecords.length} records</span>
            {activeIsibo && <span><i className="bi bi-folder" /> {activeIsibo}</span>}
          </div>
          <div className="ir-table-scroll">
            <table className="ir-table">
              <thead>
                <tr>
                  <th>Amazina y'Uwatanze Ikirego</th>
                  <th>Nimero y'Irangamuntu</th>
                  <th>Telephone</th>
                  <th>Ibisobanuro</th>
                  <th>Itariki</th>
                  <th>Status</th>
                  <th>Ibikorwa</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr><td colSpan={7} style={{ textAlign: "center", padding: 40, color: "#64748b" }}>Bitegereza...</td></tr>
                ) : paginatedRecords.length === 0 ? (
                  <tr><td colSpan={7}>
                    <div className="ir-empty-state">
                      <i className="bi bi-inbox" />
                      <p>Nta birego byoherejwe</p>
                    </div>
                  </td></tr>
                ) : (
                  paginatedRecords.map((r) => (
                    <tr key={r.id}>
                      <td style={{ fontWeight: 600, color: "#1e293b" }}>{r.complainant_name}</td>
                      <td>{r.national_id || "-"}</td>
                      <td>{r.phone || "-"}</td>
                      <td style={{ maxWidth: 200, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.description}</td>
                      <td style={{ fontSize: "0.75rem", color: "#64748b" }}>{formatDate(r.created_at)}</td>
                      <td>
                        <span className={`ir-status ${r.status === "sent_to_akagari" ? "ir-status-sent" : r.status === "sent_to_umudugudu" ? "ir-status-sent" : "ir-status-pending"}`}>
                          <i className={`bi ${r.status === "pending" ? "bi-clock" : "bi-check-circle"}`} />
                          {r.status === "sent_to_akagari" ? "Ku Kagari" : r.status === "sent_to_umudugudu" ? "Itegereje" : "Pending"}
                        </span>
                      </td>
                      <td>
                        <button
                          onClick={() => loadDetail(r.id)}
                          style={{ display: "inline-flex", alignItems: "center", gap: 4, padding: "6px 12px", background: "#003366", color: "#fff", border: "none", borderRadius: 6, fontSize: "0.75rem", fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}
                        >
                          <i className="bi bi-eye" /> Reba
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="ir-pagination">
              <button className="ir-page-btn" disabled={page <= 1} onClick={() => setPage((p) => Math.max(1, p - 1))}>
                <i className="bi bi-chevron-left" />
              </button>
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((pg) => (
                <button
                  key={pg}
                  className={`ir-page-btn ${page === pg ? "active" : ""}`}
                  onClick={() => setPage(pg)}
                >
                  {pg}
                </button>
              ))}
              <button className="ir-page-btn" disabled={page >= totalPages} onClick={() => setPage((p) => Math.min(totalPages, p + 1))}>
                <i className="bi bi-chevron-right" />
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
